import React, { useState } from "react";
import { Tooltip } from "reactstrap";

const TextWithTooltip = ({ id, text, textFull, classname }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <div>
      <span
        id={`Tooltip-${id}`}
        style={{ cursor: "pointer" }}
        className={classname}
      >{text}</span>
      {text !== textFull && (
        <Tooltip
          placement="top"
          isOpen={showTooltip}
          target={`Tooltip-${id}`}
          className="tooltip-table-dinamic"
          toggle={() => {
            setShowTooltip(!showTooltip);
          }}
        >
          {textFull}
        </Tooltip>
      )}
    </div>
  );
};

export default TextWithTooltip;
